/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_TitleInputs */

const cs_pipelines_title = /** @type {(inputs: Pipelines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

const en_pipelines_title = /** @type {(inputs: Pipelines_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines`)
};

/**
* | output |
* | --- |
* | "Pipelines" |
*
* @param {Pipelines_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_title = /** @type {((inputs?: Pipelines_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_title(inputs)
	return cs_pipelines_title(inputs)
});